import { RootState } from "../../app/state";
import { createSelector } from "@reduxjs/toolkit";

// const selectRoot = (state: RootState) => state;
export const selectGeneralSlice = (state: RootState) => state.generalState;

export const selectEditMode = createSelector(
  selectGeneralSlice,
  (state) => state.isEditMode,
);